<script lang="ts">
	import { z } from "zod";
	import Data from "./Data";
	import { getContext } from "svelte";
	import ImageView from "../../ImageView.svelte";
	import DomainView from "../../DomainView.svelte";
	import { stripTags } from "../../includes/Helpers";

	export let data: z.infer<typeof Data> = {};
	data = { layout: "default", ...data };
	export let id: string = undefined;
	export let indexInContainer: number[];

	if (data && data.content) {
		data.content.title = stripTags(data.content.title, [
			"span",
			"b",
			"font",
			"i",
		]);

		data.content.summary = stripTags(data.content.summary, [
			"span",
			"b",
			"font",
			"i",
		]);
	}

	const c: SvelteStore<number | undefined | null> = getContext(
		"parentBlockColumnCount"
	);
</script>

{#if !data || !data.content}
	<div class="adminContainerEmpty">Content Item</div>
{:else}
	<!-- svelte-ignore missing-declaration -->
	<DomainView
		category="blocks"
		type="ContentItem"
		{data}
		layout={data.layout}
		{indexInContainer}
		{id}
	>
		<a class="container co-{$c}" href={data.content.url}>
			{#if data && data.content}
				{#if data.content.poster}
					<ImageView
						src={data.content.poster}
						width="300"
						widths={[300]}
						fit="cover"
					/>
				{/if}

				<span class="title">{data.content.title}</span>

				{#if data.content.summary}
					<p>{data.content.summary}</p>
				{/if}
			{/if}
		</a>
	</DomainView>
{/if}

<style>
	.adminContainerEmpty {
		padding: 40px;
	}

	.co-1 {
		max-width: calc(100% - 10px);
	}

	.co-2 {
		max-width: calc(50% - 10px);
	}

	.co-3 {
		max-width: calc(33% - 10px);
	}

	.co-4 {
		max-width: calc(25% - 10px);
	}

	.container {
		display: block;
		width: auto;
		color: inherit;
		margin: 5px;
	}

	.container span {
		font-weight: bold;
		display: block;
	}
</style>
